<template>
    <div class="layout-comment-form layout-comment-form-read">
        <!-- 1、命盘特点、性格、六亲关系及运势等整体分析 -->
        <div v-if="pipanInfoBase.base && pipanInfoBase.base != ''" class="layout-comment-read-content">
            <div class="layout-comment-read-title">命盘特点、性格、六亲关系及运势等整体分析</div>
            <comment-content-read
                v-bind:className="'layout-comment-read-paragraph'"
                v-bind:textId="'base'"
                v-bind:textValue="pipanInfoBase.base">
            </comment-content-read>
        </div>
        <!-- 2、命局类型及强弱判断 -->
        <!-- 3、命局用神(或病药)分析 -->
        <div class="layout-comment-read-content">
            <div class="layout-comment-read-title">命局用神(或病药)分析</div>
            <div class="layout-comment-read-paragraph">
                <p>{{fateText}}，{{situationText}}，{{strongText}}</p>
                <p v-if="medicineList.length > 0">
                    <span class="layout-comment-read-label" v-for="(medicineData, index) of medicineList" v-bind:key="'medicine' + medicineData.id + Math.random(0, 10)">{{medicineData.text}}：{{medicineData.content}}<span v-bind:class="{'dsp-none': index == medicineList.length - 1}">，</span></span>
                </p>
            </div>
        </div>
        <!-- 4、大运流年详细分析 -->
        <div class="layout-comment-read-content" id="dayunliunian">
            <div class="layout-comment-read-title">大运流年详细分析</div>
            <div v-if="pipanInfoList && pipanInfoList.length == 0">
                还没有详细分析
            </div>
            <comment-list-read v-else></comment-list-read>
        </div>
        <!-- 5、其他分析 -->
        <div v-if="pipanInfoBase.other && pipanInfoBase.other != ''" class="layout-comment-read-content">
            <div class="layout-comment-read-title">其他分析</div>
            <comment-content-read
                v-bind:className="'layout-comment-read-paragraph'"
                v-bind:textId="'other'"
                v-bind:textValue="pipanInfoBase.other">
            </comment-content-read>

        </div>
        <!-- 6、注意事项及建议 -->
        <div v-if="pipanInfoBase.suggest && pipanInfoBase.suggest != ''" class="layout-comment-read-content">
            <div class="layout-comment-read-title">注意事项及建议</div>
            <comment-content-read
                v-bind:className="'layout-comment-read-paragraph'"
                v-bind:textId="'suggestread'"
                v-bind:textValue="pipanInfoBase.suggest">
            </comment-content-read>

        </div>
    </div>
</template>

<script>
import CommentListRead from './CommentListRead.vue'
import CommentContentRead from './CommentContentRead.vue'
export default {
    name: 'CommentFormRead',
    components: { CommentListRead, CommentContentRead },
    computed: {
        pipanInfoBase() {
            return this.$store.state.comment.pipanInfoBase;
        },
        pipanInfoList() {
            return this.$store.state.comment.pipanInfoList;
        },
        situationText() {
            return this.$store.state.comment.situationText;
        },
        fateText() {
            return this.$store.state.comment.fateText;
        },
        strongText() {
            return this.$store.state.comment.strongText;
        },
        medicineList() {
            return this.$store.state.comment.medicineList;
        },
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initFunc();
        }, 20);
    },
    methods: {
        initFunc() {
            window.clickWechatUrl = function(url) {
                window.location.href = url;
            }
        },
    }
}
</script>